module.exports = __webpack_public_path__ + "assets/img/mecha-24042ef8.png";